import React from 'react';

const PanelDivider = () => (
  <div
    style={{
      border: '1px solid #E0E0E0',
      marginTop: '40px',
      marginBottom: '40px',
    }}
  />
);

export default PanelDivider;